import { useFormContext } from 'react-hook-form';
import { FormField } from 'ui/formField';
import { TextArea } from 'ui/inputs';
import { useTranslations } from '../../hooks/useTranslations';
import { SnippetFieldsInputIds, SnippetFieldTestingIds } from '../../types';

export const SnippetDescription = () => {
  const fieldIdentifier = SnippetFieldsInputIds.description;
  const { t } = useTranslations();
  const { watch, setValue, clearErrors } = useFormContext();
  const snippetDescription = watch(fieldIdentifier);
  const handleSnippetDescriptionChange = (newDescription: string) => {
    setValue(SnippetFieldsInputIds.description, newDescription, { shouldDirty: true });
    clearErrors(SnippetFieldsInputIds.description);
  };
  return (
    <FormField
      inputId={SnippetFieldTestingIds.Description}
      labelText={t('label.snippetDescription')}
      hasError={false}
    >
      <TextArea
        id="snippet-description-field"
        maxLength={500}
        onChange={handleSnippetDescriptionChange}
        placeholder={t('input.snippetDescription.placeholder')}
        resize="vertical"
        value={snippetDescription}
      />
    </FormField>
  );
};
